interface HeroProps {
  children: React.ReactNode;
}

export default function Hero({ children }: HeroProps) {
  return (
    <div className="relative isolate px-6 pt-14 lg:px-8 h-screen">
      <div className="mx-auto max-w-4xl py-32">{children}</div>
    </div>
  );
}
